<app-kontable
        id="dt_store_group"
        title = "{{ 'common.stores_group_title' | translate }}"
        [columns] = "['id', 'code', 'name']"
        [titles] = "['common.id', 'common.code', 'common.name']"
        [showInfoButton]="false"
        [showRecoverButton]="true"
        [showGlobalFilter]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        [additionalRowCommands]="customRow"
        [source]="svc.list_store_groups"
        [(fireNewDataAvailable)]="newDataAvailable"
        (onAdd)="showAddOrEditDialog($event)"
        (onEdit)="showAddOrEditDialog($event)"
        (onRemove)="delete($event)">
  <ng-template #customRow data-testid="customRow" let-row>
    <p-button label="" pTooltip="{{ 'common.stores' | translate }}" icon="fa fas fa-hashtag" styleClass="ui-button-info" (onClick)="goToDetails(row)"></p-button>
  </ng-template>
</app-kontable>

<p-dialog *ngIf="showDetail"
          [width]="600"
          [(visible)]="showDetail"
          header="{{modalTitle}}"
          [responsive]="true"
          showEffect="fade"
          [modal]="true"
          (onHide)="onDialogHide()">

  <app-store-group-list-form
          [editingElement]="svc.editing_store_group"
          (onUpdateElement)="onUpdateElement($event)"
          (onAddElement)="onAddElement($event)">
  </app-store-group-list-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-group/store-group-list/store-group-list.component.html